(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name authentication.controller:AuthenticationCtrl
     *
     * @description
     *
     */
    angular
        .module('authentication')
        .controller('AuthenticationCtrl', AuthenticationCtrl);

    function AuthenticationCtrl(AuthService, $location,$window,$rootScope) {
        var vm = this;

        vm.model = {
            username: '',
            password: '',
            isLoginFailed: false,
            errors: [],
            isSSOEnabled: false,
            currentYear: new Date().getFullYear() // Set the current year
        };

      checkSSOEnabled();

      if ($rootScope.ssoLoginError) {
        vm.model.isLoginFailed = true;
        vm.model.errors=[$rootScope.ssoLoginError];
        $rootScope.ssoLoginError = null;
      }

      function checkSSOEnabled() {
        AuthService.isSSOEnabled(
          function (data) {
            vm.model.isSSOEnabled = data.isSSOEnabled;
          },
          function (error) {
            vm.model.isSSOEnabled = false;
          }
        );
      }

        vm.onLoginClick = function () {
            AuthService.doLogin(vm.model.username, vm.model.password,
                function () {
                    $location.path('/welcome');
                    $window.name='welcome';
                },
                function (error) {
                    vm.model.isLoginFailed = true;
                    vm.model.errors = error.msg;
                }
            );
        };

      vm.onADLoginClick = function () {
        AuthService.doAdLogin(
          function (data) {
            $window.location.href = data.authUrl;
          },
          function (error) {
          }
        );
      };

    }
}());
